export enum AccountRoutesNamesEnum {
  account = 'account',
  accountCreate = 'account-create',
  personalInfo = 'personal-info',
  emailVerification = 'email-verification'
}
